function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "user-aliado-avatar.ecffd809",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#FF6A13",
  fillRule: "nonzero",
  cx: 13,
  cy: 13,
  r: 13
}), /*#__PURE__*/React.createElement("g", {
  id: "user",
  transform: "translate(6.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14,13.475 L14,11.7833333 C14,9.9147699 12.4329966,8.4 10.5,8.4 L3.5,8.4 C1.56700338,8.4 0,9.9147699 0,11.7833333 L0,13.475 L14,13.475 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 7.0068627,
  cy: 3.5068627,
  r: 3.5068627
}))));

function SvgGente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-aliado-avatar.ecffd809") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGente);
export default __webpack_public_path__ + "static/media/gente.d6b97c26.svg";
export { ForwardRef as ReactComponent };